import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import * as globals from '../../globals';
import * as XLSX from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggingService } from '../../../services/logging.service';
import { HealthStatsService } from 'src/app/services/healthstats.service';
import { Namespace } from 'src/app/models/namespace.model';
import { NamespaceState } from 'src/app/enums/namespace-state.enum';

@Component({
  standalone: false,
  selector: 'app-namespaces-list',
  templateUrl: './namespaces-list.component.html',
  styleUrls: ['./namespaces-list.component.scss']
})
export class NamespacesListComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar,
    private healthStatsService: HealthStatsService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.getNamespaces();
  }

  private async getNamespaces(refresh: boolean = false) {
    try {
      this.loadingSpinner(true);
      
      if (refresh) {
        this.displaySnackBar(globals.hardRefresh_namespace);
      }

      this.healthStatsService.getNamespaces(refresh).subscribe({
        next: (data) => {
          try {
            if (data !== undefined) {
              data.forEach(namespace => namespace.state = NamespaceState[namespace.state ?? 0] ?? 'Unknown');
              this.dataSource = new MatTableDataSource(data);
            }
          }
          catch (e) {
            this.logger.logException(e);
          }
          this.loadingSpinner(false);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner(false);
        }
      });
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }

  public refresh = () => {
    this.getNamespaces(true);
  };

  async exportDataToExcel() {
    const uniqueValue = this.datePipe.transform(new Date(),globals.exportFile_dateFormat).toString();
    const fileName = `${globals.exportNamespacesFile_name}_${uniqueValue}.xlsx`;

    /* pass here the table id */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataSource.data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, globals.exportNamespacesFile_sheetName);
    /* save to file */
    XLSX.writeFile(wb, fileName);

    this.logger.logEvent('Namespaces Export Success', {fileName: fileName});
  }

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 5000});

  isLoading: boolean;
  dataSource = new MatTableDataSource<Namespace>();
  displayedColumns: string[] = globals.namespace_columns;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

}
